import React from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PageHeader, SectionCard, CardSkeleton } from "@/admin/ui";

const FIELDS = [
  ["legal_name", "admin.company.legal_name"],
  ["company_number", "admin.company.number"],
  ["registered_address", "admin.company.address"],
  ["country", "admin.company.country"],
  ["support_email", "admin.company.support"],
  ["legal_email", "admin.company.legal_email"],
  ["privacy_email", "admin.company.privacy"],
  ["phone", "admin.company.phone"],
  ["authorized_person", "admin.company.authorized"],
  ["tax_id", "admin.company.tax"],
  ["tax_office", "admin.company.tax_office"],
  ["refund_contact", "admin.company.refund_contact"],
  ["website", "admin.company.website"],
];

export default function AdminCompany() {
  const { t } = useLang();
  const [data, setData] = React.useState(null);
  const [busy, setBusy] = React.useState(false);

  const load = () => api.get("/api/admin/company").then((r) => setData(r.data));
  React.useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/api/admin/company", data); toast.success(t("common.saved")); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    setBusy(false);
  };

  return (
    <div className="space-y-6" data-testid="admin-company-page">
      <PageHeader title={t("admin.company.title")} description={t("admin.company.subtitle")}
        primary={<button type="submit" form="company-form" disabled={busy || !data} className="lp-btn-primary text-xs py-1.5 px-3" data-testid="company-save">{t("common.save")}</button>} />
      {!data ? <CardSkeleton h="h-64" /> : (
        <SectionCard>
          <form id="company-form" onSubmit={save} className="grid md:grid-cols-2 gap-4">
            {FIELDS.map(([k, key]) => (
              <div key={k} className={k === "registered_address" ? "md:col-span-2" : ""}>
                <label className="text-xs uppercase tracking-widest text-white/50 mb-2 block">{t(key)}</label>
                <input className="lp-input" value={data[k] || ""} onChange={(e) => setData({ ...data, [k]: e.target.value })} data-testid={`company-${k}`} />
              </div>
            ))}
          </form>
        </SectionCard>
      )}
    </div>
  );
}
